import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Routes, RouterModule } from '@angular/router';
import { Environment } from '../app.environment';
import { VideoSession } from '../components/video/video-session';
import { Intake } from '../models';
import { Api, Session } from '../services/index';



//import { VideoTestComponent } from '../components/video-test/video-test.component';
@Component({
  selector: 'app-thankyou',
  templateUrl: './exam-thankyou.html'
})
export class ExamThankYouComponent implements OnInit, OnDestroy {
  exam: Intake;
  examCancelled: boolean = false;
  examStarted: boolean = false;
  poller: any = null;
  visitAllowed: boolean = false;
  intakeId: number;
  isVideoTestOn: boolean;
  isShowVideoTool: boolean;
  assessmentPending:boolean = false; //has been assigned to patient, patient needs to complete assessment. 

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private changeDetectorRef: ChangeDetectorRef,
              private env: Environment,
              private router: Router,
              public session: Session,
              private video: VideoSession) { 

                this.intakeId = parseInt(route.snapshot.params['intakeId']);
                this.isShowVideoTool = true;
                this.exam = new Intake();
                
  }

  ngOnInit() {
    if( this.intakeId < 0) {
      this.isVideoTestOn = false;
      this.isShowVideoTool = false;
      //came from taking assesment, doesn't require intake id.
      return;
    }

		this.api.getIntake(this.intakeId).subscribe(result => {
      this.exam = result;

      if(!this.session.examIntake){
        this.session.examIntake = this.exam;
      }
  
      this.examStarted = (this.exam.intakeStatus === 'VS');

      if(this.exam.intakeStatus === 'AS' || this.exam.intakeStatus === 'AR'){
        this.isVideoTestOn = false;
        this.isShowVideoTool = false;
      }

      console.log('EXAM-THANKYOU.TS this.exam ? lineofBusiness:', this.exam);

      // if(this.exam.lineOfBusiness === 'BH'){
      //   console.log('this.exame.stauts',this.exam.intakeStatus)
      //   this.api.getAssessmentsAssignedToPatient(this.exam.userId).subscribe(assessments =>{
      //     console.log('EXAM-THANKYOU.TS getAssessmentsAssignedToPatient.assessments:', assessments);
      //     assessments.forEach(element => {
      //       console.log('EXAM-THANKYOU.TS assessments.array.element:', element);
      //       if(element.dateCompleted === null && element.planID == this.exam.selectedPlanId){
      //         this.assessmentPending = true;
      //       }
      //     }); 
      //   });
      // }

      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }

      if (this.session.intakeLob != 'BH') {
        let refresher = this.refreshDataPoll(() => this.updateExamStatus.apply(this), 5000);
      }
       // TODO: move this somewhere other than here
		}, ex => {
		});
  }

  getIntakeLOB(){
    return this.session.intakeLob;
  }
  
  ngOnDestroy() {
    clearInterval(this.poller);
  }

  refreshDataPoll(fn, interval) {
    let _self = this;
    return new Promise(function (resolve, reject) {
      // set polling timer
      _self.poller = setInterval(function () {
        try {
          fn();
        } catch (ex) {

        }
      }, interval);
    });
  }
  
  updateExamStatus = () => {
    this.api.getIntake(this.exam.intakeId || this.session.serverIntake.intakeId).subscribe(exam => {
      this.exam = exam;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
      if(exam.intakeStatus === 'VS'){
        this.isVideoTestOn = false;
      }

      if (!this.examCancelled && !this.examStarted) {
        this.session.examIntake = exam;
        if (exam.intakeStatus === 'CL-U' || exam.intakeStatus === 'CL-M'){
          this.examCancelled = true;
          this.session.showMenu = true;
          this.isVideoTestOn = false;
        }
        this.examStarted = (exam.intakeStatus === 'VS');
      }
      if (exam.intakeStatus === 'VC') {
        this.videoClosed(true);
        this.isVideoTestOn = false;
      }
    });
  }

  enterExamTapped() {        
    this.visitAllowed = true;
    this.session.showMenu = false;
  }

  videoClosed(closed: boolean) {
    this.visitAllowed = false;
    this.session.showMenu = true;
   // this.router.navigate(['/exam-survey']);
   this.router.navigate(['/exam-complete']);
  }

  getStarted() {
    let url = this.env.settings.mdlogixSSO + "/#/redirect?sid=" + this.session.jwtToken + "&iid=" + this.session.serverIntake.intakeId;
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = url;  
  }

  gotoDashboard() {
    this.router.navigate(['/dashboard']);
  }
  
}
